module.exports = __webpack_public_path__ + "static/media/487.bf04bee3.webp";